module.exports = __webpack_public_path__ + "img/vizio1-cover-3.1ab4e733.jpg";